<template>
  <div class="footer-container" v-if="mainData">
    <div class="footer-inner">
      <!-- 公司信息 -->
      <div class="company">
        <div class="company-heading">
          <img class="brand-logo" src="/static/image/home/brand_logo.png" alt="关盈堂" />
          <span class="brand-name">关盈堂</span>
          <strong class="company-name">温县信愿行科技有限公司</strong>
        </div>
        <p>公司地址：{{ mainData.address }}</p>
        <p>联系电话：{{ mainData.phone }}</p>
        <p>邮箱：{{ mainData.email }}</p>
      </div>

      <!-- 合规与政策 -->
      <div class="policies">
        <!-- <h2>合规与政策</h2> -->
        <!-- <div class="policy-links">
          <a href="javascript:;">用户协议</a>
          <a href="javascript:;">隐私政策</a>
          <a href="https://beian.miit.gov.cn/" target="_blank">ICP备案</a>
          <a href="javascript:;">资质合规</a>
        </div> -->
        <div class="qr-codes">
          <div class="qr-item">
            <div class="qr-box">
              <img src="/static/image/gzh.jpg" class="qr-img" alt="微信公众号" />
            </div>
            <p>微信公众号</p>
          </div>
          <div class="qr-item">
            <div class="qr-box">
              <img src="/static/image/mini_qr.jpg" class="qr-img" alt="小程序" />
            </div>
            <p>小程序</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 备案信息 -->
    <div class="footer-filing">
      <div class="filing-row">
        <a href="https://beian.miit.gov.cn/" target="_blank" class="filing-link">豫ICP备2026047663号-1</a>
        <!-- <span class="filing-sep">|</span> -->
        <!-- <a href="https://beian.mps.gov.cn/#/query/webSearch/" target="_blank"
          class="filing-link">川公网安备51011402001140号</a> -->
        <!-- <span class="filing-sep">|</span>
        增值电信业务经营许可证编号：川B2-20250053
        <span class="filing-sep">|</span>
        互联网药品信息服务资格证书编号：（川）-经营性-2024-0050
        <span class="filing-sep">|</span>
        互联网药品医疗器械信息服务备案编号：川网药械信备字(2026)000223号 -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mainData: null,
    };
  },
  created() {
    this.wjtHttp.get(this, "/api/home/v1/info", {}, false, (res) => {
      var data = res.data;
      if (data.code == 200) {
        this.mainData = data.data;
        this.mainData.email = "xinyuanxingkeji@163.com";
        this.mainData.phone = "17739169525";
        this.mainData.address =
          "河南省焦作市温县岳村街道黄河路北慈胜大街西东起第20号";
      } else {
        this.$message({
          message:
            data.msg && data.msg.length > 0
              ? data.msg
              : "信息获取异常，请联系管理员",
          type: "error",
        });
      }
    });
  },
  methods: {
    goLink(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
.footer-container {
  width: 100%;
  min-height: 332px;
  padding: 36px 0 30px;
  box-sizing: border-box;
  background: linear-gradient(105deg, #e3f7f2 0%, #fff9fa 48%, #fff9fa 67%, #e2f6f0 100%);
  color: #171717;
}

.footer-inner {
  width: min(1220px, calc(100% - 48px));
  margin: 0 auto;
  display: grid;
  grid-template-columns: 735px 1fr;
  /* 左侧公司信息贴左、右侧二维码贴右，两块垂直居中对齐 */
  align-items: center;
}

/* ── 公司信息 ── */
.company-heading {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 23px;
}

.brand-logo {
  width: 52px;
  height: 52px;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
}

.brand-name {
  font-size: 26px;
  font-weight: 700;
  color: #171717;
  letter-spacing: 1px;
  white-space: nowrap;
}

.company-name {
  font-size: 24px;
  font-weight: 600;
  color: #171717;
  white-space: nowrap;
}

.company p {
  margin: 0 0 13px;
  font-size: 17px;
  line-height: 25px;
  letter-spacing: -0.6px;
  color: #171717;
}

/* ── 合规与政策 ── */
.policies {
  display: flex;
  justify-content: flex-end;
}

.policies h2 {
  font-size: 24px;
  margin: 5px 0 24px;
  font-weight: 600;
  color: #171717;
}

.policy-links {
  display: flex;
  gap: 39px;
  white-space: nowrap;
}

.policy-links a {
  color: #171717;
  font-size: 20px;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.2s;
}

.policy-links a:hover {
  color: #009798;
}

/* ── 二维码 ── */
.qr-codes {
  display: flex;
  gap: 40px;
  margin-top: 0;
}

.qr-item {
  text-align: center;
}

.qr-box {
  width: 117px;
  height: 117px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.qr-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.qr-codes p {
  margin: 8px 0 0;
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  color: #171717;
}

/* ── 备案信息 ── */
.footer-filing {
  width: min(1220px, calc(100% - 48px));
  margin: 30px auto 0;
}

.filing-row {
  font-size: 16px;
  color: #527f77;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px 16px;
}

.filing-link {
  color: #527f77;
  text-decoration: none;
}

.filing-link:hover {
  color: #009798;
}

.filing-sep {
  color: #ccc;
}

/* ── Responsive: Tablet (<=1024px) ── */
@media screen and (max-width: 1024px) {
  .footer-inner {
    grid-template-columns: 60% 40%;
  }

  .company-heading {
    gap: 15px;
  }

  .brand-name {
    font-size: 22px;
  }

  .company-name {
    font-size: 20px;
    white-space: normal;
  }

  .policy-links {
    gap: 20px;
  }

  .filing-row {
    font-size: 12px;
  }
}

/* ── Responsive: Mobile (<=640px) ── */
@media screen and (max-width: 640px) {
  .footer-container {
    padding: 28px 0 20px;
  }

  .footer-inner {
    grid-template-columns: 1fr;
    gap: 25px;
    align-items: start;
  }

  /* 单列时恢复左对齐，避免二维码被推到右边 */
  .policies {
    justify-content: flex-start;
  }

  .company-heading {
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 16px;
  }

  .brand-logo {
    width: 40px;
    height: 40px;
  }

  .brand-name {
    font-size: 20px;
  }

  .company-name {
    font-size: 16px;
  }

  .company p {
    font-size: 13px;
    letter-spacing: 0;
    margin-bottom: 8px;
  }

  .policies h2 {
    font-size: 18px;
    margin-bottom: 14px;
  }

  .policy-links {
    gap: 22px;
  }

  .policy-links a {
    font-size: 15px;
  }

  .qr-codes {
    gap: 24px;
    margin-top: 14px;
  }

  .qr-box {
    width: 90px;
    height: 90px;
  }

  .qr-codes p {
    font-size: 14px;
  }

  .filing-row {
    font-size: 11px;
    line-height: 1.8;
  }
}
</style>
